<div class="liste-trajets">
	<p-toolbar styleClass="toolbar">
		<div class="section-toolbar">
			<div class="titre-trajets">
				{{ 'GESTION_NAVETTE.TRAJETS.TITRE_TRAJETS' | translate }}
			</div>
			<p-button type="button"
			          (onClick)="onCreerClick()"
			          icon="pi pi-plus-circle"
			          [disabled]="boutonsDesactives()"
			          label="{{ 'GLOBAL.BTN_CREER' | translate }}"/>
		</div>
		<div class="section-toolbar">
			<app-selecteur-periode (changerPeriode)="changerSemaine($event)"
			                       [boutonsDesactives]="boutonsDesactives()">
			</app-selecteur-periode>
		</div>

		<app-filtrage-trajets [suggestionsLieux]="suggestionsLieuxAutocomplete"
		                      (filtresAppliques)="recupererFiltres($event)"
		                      (filtresReinitialises)="reinitialiserFiltres()"
		                      [estBoutonFiltreDesactive]="boutonsDesactives()">
		</app-filtrage-trajets>
	</p-toolbar>
	<app-affichage-liste-trajets [trajets]="trajetsFiltres()"
	                             [enChargement]="enChargement()"
	                             [messageAucunTrajet]="messageAucunTrajet()"
	                             [modeAffichage]="MODE_NAVETTE.GESTION"
	                             (rafraichirListe)="recupererTrajets()">
	</app-affichage-liste-trajets>
</div>
